import { useEffect } from "react";
import { Close } from "../icons";

export default function WelcomePopup({
    isOpen,
    title,
    message,
    onClose,
}) {
    useEffect(() => {
        if (!isOpen) return;

        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose?.();
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [isOpen, onClose]);

    if (!isOpen || (!title && !message)) return null;

    return (
        <div
            className="werner-welcomePopup-overlay"
            onMouseDown={(event) => {
                if (event.target === event.currentTarget) {
                    onClose?.();
                }
            }}
        >
            <div
                className="werner-welcomePopup"
                role="dialog"
                aria-modal="true"
                aria-labelledby="werner-welcomePopup-title"
            >
                <div className="werner-welcomePopup-header">
                    <div className="werner-welcomePopup-headerText">
                        {title && (
                            <h3 id="werner-welcomePopup-title" className="werner-welcomePopup-title">
                                {title}
                            </h3>
                        )}
                        {message && (
                            <p className="werner-welcomePopup-message">{message}</p>
                        )}
                    </div>

                    <button
                        type="button"
                        className="werner-welcomePopup-close"
                        onClick={() => onClose?.()}
                        aria-label="Close welcome popup"
                        title="Close"
                    >
                        <Close className="werner-welcomePopup-closeIcon" aria-hidden="true" />
                    </button>
                </div>
            </div>
        </div>
    );
}